export default __webpack_public_path__ + "static/media/LOGO.483bbbf0.png";